export default {
    "fr": {
        "OEA Full": "OEA Full",
        "The AEO Full certification guarantees": "La certification OEA Full garantit que les dimensions sûreté des opérations et conformité douanière sont intégrées dans les process opérationnels d’ASA.",
        "ISO 9001": "Certification ISO 9001:",
        "The Quality policy": "La politique Qualité est au centre de notre activité et de fait, ASA a obtenu la Certification ISO 9001 en 2015. Les process, l’implication managériale, à travers les revues de direction régulières et la tenue des KPI’s permettent un pilotage en conformité avec nos engagements."
    },
    "en": {
        "OEA Full": "OEA Full",
        "The AEO Full certification guarantees": "The AEO Full certification guarantees that the security of operations and customs compliance dimensions are integrated into ASA's operational processes.",
        "ISO 9001": "ISO 9001 certification:",
        "The Quality policy": "The Quality policy is at the center of our activity and in fact, ASA obtained ISO 9001 Certification in 2015. The processes, managerial involvement, through regular management reviews and the keeping of KPIs allow management in accordance with our commitments."
    }
}
